import { FunctionComponent, useEffect, useState } from "react";
import { Icon } from "../Icon";

const CatalogArea: FunctionComponent = () => {
  const [showContent, setShowContent] = useState(false);
  const catalogArray = [
    { name: "Cadenas Macizas", pdf: "chain", solid: true },
    { name: "Otras Cadenas", pdf: "chain", solid: false },
    { name: "Pulseras Macizas", pdf: "brazalete", solid: true },
    { name: "Otras Pulseras", pdf: "brazalete", solid: false },
    { name: "Dijes", pdf: "pendant", solid: false },
    { name: "Anillos", pdf: "ring", solid: false },
    { name: "Aros", pdf: "hoop", solid: false },
    { name: "Fornituras", pdf: "finding", solid: false },
  ];

  useEffect(() => {
    setTimeout(() => setShowContent(true), 2000);
  }, []);

  return (
    <section className="catalogs_container">
      {showContent && (
        <>
          <div className="catalogs_titles">
            <h3>Catálogos</h3>
            <p className="catalogs_info_text">
              También podés descargar nuestros catálogos y hacernos tu pedido
              por email o whatsapp!
            </p>
          </div>
          <section className="catalogs_subcontainer">
            <div className="catalogs_download">
              {catalogArray.map((c) => {
                return (
                  <div className="catalogs_item" key={c.name}>
                    <Icon iconName="pdf_icon" className="catalogs_icon" />
                    <div className="catalogs_item_elements">
                      <p>{c.name}</p>
                        <a
                          href={
                            window.location.origin +
                            "/catalog/" +
                            c.pdf +
                            "/" +
                            c.solid
                          }
                          target={"_blank"}
                          className="catalog_download_button"
                        >
                          <button>Descargar</button>
                        </a>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="catalogs_img_container">
              <img
                src="/assets/images/catalogImage.png"
                alt="ilustracion de catálogo"
                className="catalogs_ilustration"
              />
            </div>
          </section>
        </>
      )}
    </section>
  );
};

export default CatalogArea;
